import script from "./FundraisingTalkingPointsView.vue?vue&type=script&setup=true&lang=js"
export * from "./FundraisingTalkingPointsView.vue?vue&type=script&setup=true&lang=js"

import "./FundraisingTalkingPointsView.vue?vue&type=style&index=0&id=aa44754c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa44754c"]])

export default __exports__